module.exports = __webpack_public_path__ + "static/user-avatar-0e85ca94072e9878cd88442f7c7cbb1a.png";